import { init } from '@plausible-analytics/tracker'
import './src/styles/global.css'

init({
  domain: 'ytmp4.app',
  endpoint: 'https://pb.ytmp3tube.com/api/event',
})